export class GearboxInstanceContext {
    templateId: string;
    ruleId: string;
    map?: any;
}
